export const normalizeAppText = (value) => String(value || "").trim().toLowerCase();

export const getUserAppIds = (user) => {
    if (!Array.isArray(user?.my_apps)) return null;
    return user.my_apps.map((id) => String(id));
};

export const findAppByModule = (apps = [], moduleName = "") => {
    const moduleKey = normalizeAppText(moduleName);
    if (!moduleKey) return null;

    return apps.find((app) => {
        const name = normalizeAppText(app?.name);
        const titleEn = normalizeAppText(app?.titleEn);
        const titleAr = String(app?.titleAr || "");

        if (moduleKey === "sales") {
            return name === "sales" || name.includes("sale") || titleEn.includes("sale") || titleAr.includes("مبيعات");
        }

        if (moduleKey === "purchases") {
            return name === "purchases" || name.includes("purchase") || titleEn.includes("purchase") || titleAr.includes("مشتريات");
        }

        if (moduleKey === "contracts") {
            return name.includes("contract") || titleEn.includes("contract") || titleAr.includes("عقود");
        }

        if (moduleKey === "finance") {
            return name === "financial" || name.includes("finance") || titleEn.includes("finance") || titleAr.includes("مالي");
        }

        return name === moduleKey || name.includes(moduleKey) || titleEn.includes(moduleKey);
    }) || null;
};

export const userHasAppAccess =(user, apps = [], moduleName = "") => {
    const userAppIds = getUserAppIds(user);
    if (!userAppIds || userAppIds.length === 0) return true;

    const app = findAppByModule(apps, moduleName);
    if (!app) return false;

    return userAppIds.includes(String(app?._id || app?.id));
};
